import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'pagination-dropdown',
  templateUrl: 'pagination-dropdown.component.html',
  styleUrls: ['pagination-dropdown.component.scss'],
})
export class PaginationDropdownComponent {

  @Input() perName: string = 'page';
  @Input() selected: number;
  @Input() perData: Array<any> = [];
  @Input() disabled: boolean = false;
  @Input() dropup: boolean = false;
  @Input() color: string = 'blue';

  @Output() select: EventEmitter<any> = new EventEmitter();

  onDropdownItemClick(item: any) {
    if (this.disabled) { return; }
    this.selected = item;
    this.select.emit(item);
  }
}
